import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ContactUsLanding from "../views/ContactUsLanding";
import { Helmet } from "react-helmet-async";

export default function ContactUs(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ContactUsLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Contact Us | Zanzibar Mission Tours</title>
        <meta
          name="description"
          content="Get in touch with Zanzibar Mission Tours. Contact us for inquiries about tours, safaris, and travel packages in Tanzania and Zanzibar."
        />
        <meta
          property="og:title"
          content="Contact Us | Zanzibar Mission Tours"
        />
        <meta
          property="og:description"
          content="Get in touch with Zanzibar Mission Tours for all your travel inquiries."
        />
        <meta
          property="og:url"
          content="https://zanzibarmissiontour.com/#/contact_us"
        />
      </Helmet>
      {view}
    </>
  );
}
